import React from "react";
import Items from "./items";


export class Main extends React.Component {
    render(){
        return (
            <main>
                <div className='list'>
                    <Items items={this.props.items} onAdd = {this.props.onAdd} onShowItem={this.props.onShowItem}/>
                </div>
            </main>
          )
    }
}
export default Main;